import { tWithKeyAttr as t } from "../i18nHelper";
export interface IInquiryUpdate {
  id: string;
  date: Date;
  text: string;
}
export interface IInquiry {
  id: string;
  issued: Date;
  inquiry: string;
  category: string;
  status: string;
  belongsTo: string | null;
  urgent: boolean;
  userId: string;
  updates: IInquiryUpdate[];
}

export const inquiries: IInquiry[] = [
  {
    id: "1",
    issued: new Date(),
    category: t("FIRST_INQUIRY"),
    inquiry: t("LOREM_IPSUM_TRANSLATION"),
    status: "inProgress",
    belongsTo: "1",
    urgent: true,
    userId: "5",
    updates: [
      {
        id: "1",
        date: new Date(),
        text: t("BRAIT_VELCHAT_TZURK_MUNAHF"),
      },
    ],
  },
  {
    id: "2",
    issued: new Date(),
    category: t("FIRST_INQUIRY"),
    inquiry: t("BRAIT_VELCHAT_TZURK_MUNACHAF"),
    status: "notYetAddressed",
    belongsTo: "1",
    urgent: true,
    userId: "2",
    updates: [],
  },
  {
    id: "3",
    issued: new Date(),
    category: t("FIRST_INQUIRY"),
    inquiry: t("NOLUM_ARVUS_SAPIEN"),
    status: "notYetAddressed",
    belongsTo: null,
    urgent: true,
    userId: "3",
    updates: [],
  },
  {
    id: "4",
    issued: new Date(),
    category: t("FIRST_INQUIRY"),
    inquiry: t("LEHAAMIT_KRASHK_SKAIT_DZ_MA"),
    status: "notYetAddressed",
    belongsTo: null,
    urgent: true,
    userId: "4",
    updates: [],
  },
  {
    id: "5",
    issued: new Date(),
    category: t("FIRST_INQUIRY"),
    inquiry: t("LEHAAMIT_KRASHK_SKAIT_DZ_MA"),
    status: "notYetAddressed",
    belongsTo: null,
    urgent: true,
    userId: "6",
    updates: [],
  },
  {
    id: "6",
    issued: new Date(),
    category: t("FIRST_INQUIRY"),
    inquiry: t("LEHAAMIT_KRASHK_SKAIT_DZ_MA"),
    status: "notYetAddressed",
    belongsTo: null,
    urgent: false,
    userId: "7",
    updates: [],
  },
  {
    id: "7",
    issued: new Date(),
    category: t("FIRST_INQUIRY"),
    inquiry: t("LEHAAMIT_KRASHK_SKAIT_DZ_MA"),
    status: "notYetAddressed",
    belongsTo: null,
    urgent: false,
    userId: "8",
    updates: [],
  },
];
